





$(document).ready(function() {
  //menu mob
  $(".mob-menu__link").on('click', function() {
    $('.mob-menu').slideToggle(400)
    $("body").toggleClass("menu-active").toggle(100);
  });
  $('.toogle-menu').on('click', function() {
    $("body").toggleClass("menu-active");
    $('.mob-menu').slideToggle(400);

  });
  $('.menu-close').on('click', function() {
    $("body").toggleClass("menu-active");
    $('.mob-menu').slideToggle(400)
  });

  if($(".timer").length > 0){
    function updater(d, h, m, s) {
      // День сброса - 27 сентября 2015 года (и далее каждые три дня)
      var baseTime = new Date(2015, 8, 27);
      // Период сброса — 1 день
      var period = 1*24*60*60*1000;

      function update() {
        var cur = new Date();
        // сколько осталось миллисекунд
        var diff = period - (cur - baseTime) % period;
        // сколько миллисекунд до конца секунды
        var millis = diff % 1000;
        diff = Math.floor(diff/1000);
        // сколько секунд до конца минуты
        var sec = diff % 60;
        if(sec < 10) sec = "0"+sec;
        diff = Math.floor(diff/60);
        // сколько минут до конца часа
        var min = diff % 60;
        if(min < 10) min = "0"+min;
        diff = Math.floor(diff/60);
        // сколько часов до конца дня
        var hours = diff % 24;
        if(hours < 10) hours = "0"+hours;
        var days = Math.floor(diff / 24);
        d.innerHTML = days;
        h.innerHTML = hours;
        m.innerHTML = min;
        s.innerHTML = sec;

        // следующий раз вызываем себя, когда закончится текущая секунда
        setTimeout(update, millis);
      }
      setTimeout(update, 0);
    }

    updater(document.getElementById("days"),
      document.getElementById("hours"), document.getElementById("minutes"),
      document.getElementById("seconds"));

    updater(document.getElementById("days1"),
      document.getElementById("hours1"), document.getElementById("minutes1"),
      document.getElementById("seconds1"));
  }



  //faq
  ! function(i) {
    var o, n;
    i(".faq-item-top, .prices-item__top").on("click", function() {
      o = i(this).parents(".faq-item, .prices-item2"), n = o.find(".faq-item-text, .prices-item__detail"),
        o.hasClass("active_block") ? (o.removeClass("active_block"),
          n.slideUp()) : (o.addClass("active_block"), n.stop(!0, !0).slideDown(),
          o.siblings(".active_block").removeClass("active_block").children(
            ".faq-item-text, .prices-item__detail").stop(!0, !0).slideUp())
    })
  }(jQuery);

  //price2
/*  ! function(i) {
    var o2, n2;
    i(".prices-item__title2").on("click", function() {
      o2 = i(this).parents(".faq-item"), n2 = o2.find(".prices-item__detail"),
        o2.hasClass("active_block") ? (o2.removeClass("active_block"),
          n2.slideUp()) : (o2.addClass("active_block"), n2.stop(!0, !0).slideDown(),
          o2.siblings(".active_block").removeClass("active_block").children(
            ".prices-item__detail").stop(!0, !0).slideUp())
    })
  }(jQuery);*/


  //price decor
  $(".prices-item__service").each(function(){
    var price= $(".prices-item__service-price").width();
    var w100 = 100;
    var wprices =  $(".prices-item__service").width();
    var name = $(".prices-item__service-name").width();
    var nameWidth = wprices - price;

    $(".prices-item__service-name").width(nameWidth);
   /* console.log(price);
    console.log(wprices);
    console.log( $(".prices-item__service-name").width(nameWidth));*/
  });
  if($(window).width() > 1199){
    if(".permanent-composition"){
      $('.permanent-composition-items').each(function () {
        var heightpcitiltle = [];
        $('.permanent-composition-item__title' +
          '', this).each(function () {
          heightpcitiltle.push($(this).height());
        });
        $('.permanent-composition-item__title ', this).height(Math.max.apply(null, heightpcitiltle));
      });
    }
    if(".permanente-garant"){
      $('.permanente-garant').each(function () {
        var heightpg = [];
        $('.permanente-garant-item' +
          '', this).each(function () {
          heightpg.push($(this).height());
        });
        $('.permanente-garant-item ', this).height(Math.max.apply(null, heightpg));
      });
    }
  }

  if($(window).width() > 767){
    var fcopiwidth = $(".footer-copiright").width();
    var fprivatwidth = $(".footer-privat").width();
    var fpfc = fprivatwidth - fcopiwidth;
    console.log(fpfc)
    $(".footer-social").css("padding-left" , fpfc + "px")
  }


  $('.teachers-slider').owlCarousel({
    loop: true,
    autoplay: false,
    nav: true,
    navText: ['<i class="ico_arrow_left"></i>', '<i class="ico_arrow_right"></i>'],
    dots: true,
    items: 1,
    autoHeight: true
  });
  $('.innate-defects-slider').on('initialized.owl.carousel changed.owl.carousel', function(e) {
    if (!e.namespace) return
    var carousel = e.relatedTarget
    $('#ids-info').text(carousel.relative(carousel.current()) + 1 + '/' + carousel.items().length)
  });
  $('.innate-defects-slider').owlCarousel({
    loop: true,
    autoplay: false,
    nav: false,
    autoHeight: true,
    dots: true,
    items: 1
  });


  //owl 1
  var screenshotsCarousel = $('.screenshot-carousel');
  screenshotsCarousel.on({
    'initialized.owl.carousel': function(){
      screenshotsCarousel.find('.image-holder').fadeIn(1200);
      $("#screenshots .carousel-decoration").fadeIn(1200);
      $("#screenshots-spinner").fadeOut(100);
    }
  })
    .owlCarousel({
      autoplay: false,
      autoplayTimeout: 2000,
      smartSpeed: 400,
      autoplayHoverPause:true,
      loop: true,
      center: true,
      margin: 100,
      dots: true,
      nav: false,
      navText: false,
      responsive : {
        // breakpoint from 0 up
        0 : {

        },
        // breakpoint from 320 up
        320 : {
          items : 1,
          slideBy: 1
        },
        // breakpoint from 480 up
        480 : {
          items : 1,
          slideBy: 1
        },
        // breakpoint from 768 up
        768 : {
          items : 1,
          slideBy: 1
        },
        // breakpoint from 992 up
        992 : {
          items : 2,
          slideBy: 1
        },
        // breakpoint from 1200 up
        1200 : {
          items : 2,
          slideBy: 1
        },
        // breakpoint from 1200 up
        1600 : {
          items : 2,
          slideBy: 1
        }
      }
    });
  // Custom Owl Controls
  if($(window).width() > 1200){

    var screenshotcarouselHeight= $(".screenshot-carousel").height();

    $(".carousel-decoration").height(screenshotcarouselHeight);
    $('.screenshot-carousel').height();
  /*  console.log($(".carousel-decoration").height())
    console.log($(".screenshot-carousel").height())*/
  }
  $('#screenshots .custom-owl-next').click(function() {
    screenshotsCarousel.trigger('next.owl.carousel', [600]);
  })
  $('#screenshots .custom-owl-prev').click(function() {
    // With optional speed parameter
    // Parameters has to be in square bracket '[]'
    screenshotsCarousel.trigger('prev.owl.carousel', [600]);
  })

  // Add classes to neighbor items
  $(".screenshot-carousel").on('translated.owl.carousel', function(){
    $('.owl-item').removeClass('neighbor');
    var currenSlide = $('.screenshot-carousel .owl-item.center');
    currenSlide.next('.owl-item').addClass('neighbor');
    currenSlide.prev('.owl-item').addClass('neighbor');
  });

  // Scale owl items
  $(".screenshot-carousel").on('translate.owl.carousel', function(){
    $('.image-holder').removeClass('translate');
    $('.image-holder').addClass('translate');
  });

  $(".screenshot-carousel").on('translated.owl.carousel', function(){
    $('.image-holder').removeClass('translate');
  });

  if (screen.width <= 380) {
    $(".carousel-decoration").removeAttr("z-index");
    $('.carousel-decoration').css('z-index','initial');
  }

  var screenshotsCarousel2 = $('.screenshot-carousel2');
  screenshotsCarousel2.on({
    'initialized.owl.carousel': function(){
      screenshotsCarousel2.find('.image-holder').fadeIn(1200);
      $("#screenshots .carousel-decoration").fadeIn(1200);
      $("#screenshots-spinner").fadeOut(100);
    }
  })
    .owlCarousel({
      autoplay: false,
      autoplayTimeout: 2000,
      smartSpeed: 400,
      autoplayHoverPause:true,
      loop: true,
      center: true,
      margin: 0,
      dots: true,
      nav: false,
      navText: false,
      responsive : {
        // breakpoint from 0 up
        0 : {

        },
        // breakpoint from 320 up
        320 : {
          items : 1,
          slideBy: 1
        },
        // breakpoint from 480 up
        480 : {
          items : 1,
          slideBy: 1
        },
        // breakpoint from 768 up
        768 : {
          items : 2,
          slideBy: 1
        },
        // breakpoint from 992 up
        992 : {
          items : 3,
          slideBy: 1
        },
        // breakpoint from 1200 up
        1200 : {
          items : 3,
          slideBy: 1
        },
        // breakpoint from 1200 up
        1600 : {
          items : 3,
          slideBy: 1
        }
      }
    });


  // Custom Owl Controls


    var screenshotcarouselHeight2= $(".screenshot-carousel2").height();
    $('.screenshot-carousel2').height();


  $('#screenshots .custom-owl-next').click(function() {
    screenshotsCarousel2.trigger('next.owl.carousel', [600]);
  })
  $('#screenshots .custom-owl-prev').click(function() {
    // With optional speed parameter
    // Parameters has to be in square bracket '[]'
    screenshotsCarousel2.trigger('prev.owl.carousel', [600]);
  })

  // Add classes to neighbor items
  $(".screenshot-carousel2").on('translated.owl.carousel', function(){
    $('.owl-item').removeClass('neighbor');
    var currenSlide2 = $('.screenshot-carousel2 .owl-item.center');
    currenSlide2.next('.owl-item').addClass('neighbor');
    currenSlide2.prev('.owl-item').addClass('neighbor');
  });

  // Scale owl items
  $(".screenshot-carousel2").on('translate.owl.carousel', function(){
    $('.image-holder').removeClass('translate');
    $('.image-holder').addClass('translate');
  });

  $(".screenshot-carousel2").on('translated.owl.carousel', function(){
    $('.image-holder').removeClass('translate');
  });

  //3
  var screenshotsCarousel3 = $('.screenshot-carousel3');
  screenshotsCarousel3.on({
    'initialized.owl.carousel': function(){
      screenshotsCarousel3.find('.image-holder').fadeIn(1200);
      $("#screenshots .carousel-decoration").fadeIn(1200);
      $("#screenshots-spinner").fadeOut(100);
    }
  })
    .owlCarousel({
      autoplay: false,
      autoplayTimeout: 2000,
      smartSpeed: 400,
      autoplayHoverPause:true,
      loop: true,
      center: true,
      margin: 100,
      dots: true,
      nav: false,
      navText: false,
      responsive : {
        // breakpoint from 0 up
        0 : {

        },
        // breakpoint from 320 up
        320 : {
          items : 1,
          slideBy: 1
        },
        // breakpoint from 480 up
        480 : {
          items : 1,
          slideBy: 1
        },
        // breakpoint from 768 up
        768 : {
          items : 1,
          margin:50,
          slideBy: 1
        },
        // breakpoint from 992 up
        992 : {
          items : 1,
          margin:50,
          slideBy: 1
        },
        // breakpoint from 1200 up
        1200 : {
          items : 1.65,
          slideBy: 1
        },
        // breakpoint from 1200 up
        1600 : {
          items : 1.78,
          slideBy: 1,
          //stagePadding: 230,
        }
      }
    });


  // Custom Owl Controls


  var screenshotcarouselHeight3= $(".screenshot-carousel3").height();
  $('.screenshot-carousel3').height();


  $('#screenshots .custom-owl-next').click(function() {
    screenshotsCarousel3.trigger('next.owl.carousel', [600]);
  })
  $('#screenshots .custom-owl-prev').click(function() {
    // With optional speed parameter
    // Parameters has to be in square bracket '[]'
    screenshotsCarousel3.trigger('prev.owl.carousel', [600]);
  })

  // Add classes to neighbor items
  $(".screenshot-carousel3").on('translated.owl.carousel', function(){
    $('.owl-item').removeClass('neighbor');
    var currenSlide3 = $('.screenshot-carousel3 .owl-item.center');
    currenSlide3.next('.owl-item').addClass('neighbor');
    currenSlide3.prev('.owl-item').addClass('neighbor');
  });

  // Scale owl items
  $(".screenshot-carousel3").on('translate.owl.carousel', function(){
    $('.image-holder').removeClass('translate');
    $('.image-holder').addClass('translate');
  });

  $(".screenshot-carousel3").on('translated.owl.carousel', function(){
    $('.image-holder').removeClass('translate');
  });

  if (screen.width <= 380) {
    $(".carousel-decoration").removeAttr("z-index");
    $('.carousel-decoration').css('z-index','initial');
  }
  /*$(".screenshot-carousel2 .owlCarousel").owlCarousel({
    margin:0,
    responsive : {
      // breakpoint from 0 up
      0 : {

      },
      // breakpoint from 320 up
      320 : {
        items : 1,
        slideBy: 1
      },
      // breakpoint from 480 up
      480 : {
        items : 1,
        slideBy: 1
      },
      // breakpoint from 768 up
      768 : {
        items : 1,
        slideBy: 1
      },
      // breakpoint from 992 up
      992 : {
        items : 3,
        slideBy: 3
      },
      // breakpoint from 1200 up
      1200 : {
        items : 3,
        slideBy: 1
      },
      // breakpoint from 1200 up
      1600 : {
        items : 3,
        slideBy: 1
      }
    }
  });*/

  $(".link-form, .prices-item__detail-btn").on("click", function (event) {
    //отменяем стандартную обработку нажатия по ссылке
    event.preventDefault();
    //забираем идентификатор бока с атрибута href
    var id  = $(this).attr('href'),

      //узнаем высоту от начала страницы до блока на который ссылается якорь
      top = $(id).offset().top;

    //анимируем переход на расстояние - top за 1500 мс
    $('body,html').animate({scrollTop: top}, 1500);
  });









  //лавный скролл, не такой резкий а мягкий
  SmoothScroll({ stepSize: 100 });


  $(function() {
    $(".app-form").submit(function(event) {
      var msg=$(this).serialize();
      event.preventDefault();
      $.ajax({
        type:'POST',
        url:"sender.php",
        data:msg,//data:msg+"&action=sendform&add=Y"
        cache:false,
        success:function(data){
          $("#appform1")[0].reset();
          $("#appform2")[0].reset();

          $(".app-form__submit").attr('disabled', 'disabled');
          setTimeout(function(){location.href="grazie-unghie.html"} , 300);
        },
        error:function(data){
          alert('Ошибка соединения');
        }
      });
    });

  });
  $(function() {
    $(".app-form2").submit(function(event) {
      var msg=$(this).serialize();
      event.preventDefault();
      $.ajax({
        type:'POST',
        url:"sender.php",
        data:msg,//data:msg+"&action=sendform&add=Y"
        cache:false,
        success:function(data){
          $("#appform1")[0].reset();
          $("#appform2")[0].reset();
          $("#appform3")[0].reset();

          $(".app-form__submit").attr('disabled', 'disabled');
          setTimeout(function(){location.href="grazie-corsiextensionciglia.html"} , 300);
        },
        error:function(data){
          alert('Ошибка соединения');
        }
      });
    });

  });
  $(function() {
    $(".app-form-timer").submit(function(event) {
      var msg=$(this).serialize();
      event.preventDefault();
      $.ajax({
        type:'POST',
        url:"sender.php",
        data:msg,//data:msg+"&action=sendform&add=Y"
        cache:false,
        success:function(data){
          $("#appform1")[0].reset();
          $("#appform2")[0].reset();

          $(".app-form__submit").attr('disabled', 'disabled');
          setTimeout(function(){location.href="grazie-truccopermanente.html"} , 300);
        },
        error:function(data){
          alert('Ошибка соединения');
        }
      });
    });
  });

  //app-form-ciglio
  $(function() {
    $(".app-form-ciglio").submit(function(event) {
      var msg=$(this).serialize();
      event.preventDefault();
      $.ajax({
        type:'POST',
        url:"sender.php",
        data:msg,//data:msg+"&action=sendform&add=Y"
        cache:false,
        success:function(data){
          $("#appform1")[0].reset();
          $("#appform2")[0].reset();

          $(".app-form__submit").attr('disabled', 'disabled');
          setTimeout(function(){location.href="grazie-ciglia.html"} , 300);
        },
        error:function(data){
          alert('Ошибка соединения');
        }
      });
    });
  });

  $(function() {
    $(".app-form-ciglia-ua").submit(function(event) {
      var msg=$(this).serialize();
      event.preventDefault();
      $.ajax({
        type:'POST',
        url:"sender.php",
        data:msg,//data:msg+"&action=sendform&add=Y"
        cache:false,
        success:function(data){
          $("#appform1")[0].reset();
          $("#appform2")[0].reset();

          $(".app-form__submit").attr('disabled', 'disabled');
          setTimeout(function(){location.href="thank.html"} , 300);
        },
        error:function(data){
          alert('Ошибка соединения');
        }
      });
    });
  });
  $(function() {
    $(".app-form-ua").submit(function(event) {
      var msgUa=$(this).serialize();
      event.preventDefault();
      $.ajax({
        type:'POST',
        url:"sender.php",
        data:msgUa,//data:msg+"&action=sendform&add=Y"
        cache:false,
        success:function(data){
          $("#appform1")[0].reset();
          $("#appform2")[0].reset();
          $("#appform3")[0].reset();

          $(".app-form__submit").attr('disabled', 'disabled');
          setTimeout(function(){location.href="thank.html"} , 300);
        },
        error:function(data){
          alert('Ошибка соединения');
        }
      });
    });
  });

/*  ////ajax form, clear form on success,block btn#submit,timeout redirect
  $(".app-form").submit(function(event){
    event.preventDefault();
    submitForm();

  });
  function submitForm(){
  /!*  var name = $(".app-form__input-name").val();
    var tel = $(".app-form__input-phone").val();*!/

    var user_name    = $(".app-form__input-name").val();
    var user_phone   = $(".app-form__input-phone").val();
    var app_formname = $('.app-form-name').val();

    $.ajax({
      type: "POST",
      url: "sender.php",
      data:{
        "user_name":    user_name,
        "user_email":   user_phone,
        "app_formname": app_formname
      },
   /!*   data: "name=" + name + "&tel=" + tel,*!/
      success : function(data){
          $("#appform1")[0].reset();
          $("#appform2")[0].reset();

        $(".app-form__submit").attr('disabled', 'disabled');
        setTimeout(function(){location.href="grazie-unghie.html"} , 300);
      }
    });
  }*/

});



